export const pricing2 = {
  navigation: {
    pricing: "Pricing",
    products: "What can you sell?",
    comparison: "Comparison",
    faq: "FAQ",
    login: "Login",
    freeStart: "Start Free"
  },
  hero: {
    title: "Get more.\nPay less.",
    subtitle: "No surprises: simple and transparent pricing.",
    commission: "4%",
    description: "4% + €0.30 commission on each sale processed through us. If you handle payments directly, no commission."
  },
  singlePackage: {
    badge: "First 2 weeks free",
    price: "30",
    currency: "€",
    period: "+ VAT/mo",
    aiCredits: "100 AI credits",
    aiCreditsNote: "to get started",
    trialNote: "Try it free for 3 days, risk-free",
    ctaButton: "Start now – free",
    whyWorthIt: "Why is it worth it?",
    commissionNote: "4% + €0.30 commission on online payments. No commission on on-site payments.",
    benefits: [
      "No hidden costs",
      "Cancel anytime",
      "14-day free trial",
      "100 AI credits to start"
    ]
  },
  setupSection: {
    title: "No time to set up? We'll build it for you.",
    subtitle: "One-time fee, and your entire system is ready — then just use it with your monthly plan.",
    badge: "One-time fee",
    price: "150",
    currency: "€",
    period: "+ VAT",
    ctaButton: "Start now – free",
    benefits: [
      "No hidden costs",
      "Free initial consultation",
      "Response within 48 hours",
      "Satisfaction guarantee"
    ],
    features: [
      { text: "Complete website built with your branding", icon: "Globe" },
      { text: "Products and services uploaded", icon: "ShoppingBag" },
      { text: "Appointment booking system configured", icon: "Clock" },
      { text: "Payment system setup", icon: "CreditCard" },
      { text: "Domain connection and technical settings", icon: "Settings" },
      { text: "Initial marketing content created", icon: "TrendingUp" },
      { text: "Email marketing system setup", icon: "Mail" },
      { text: "SEO optimization and Google settings", icon: "Search" },
      { text: "Social media accounts connected", icon: "Users" },
      { text: "Personal training and handover", icon: "UserCheck" }
    ],
    note: "For both new and existing businesses"
  },
  setupPackage: {
    badge: "One-time fee",
    title: "Full setup",
    price: "150",
    currency: "€",
    period: "+ VAT",
    subtitle: "We set everything up for you – just get started",
    ctaButton: "Start now – free",
    benefits: [
      "No hidden costs",
      "Free initial consultation",
      "Response within 48 hours",
      "Satisfaction guarantee"
    ],
    features: [
      { text: "Complete website built with your branding", icon: "Globe" },
      { text: "Products and services uploaded", icon: "ShoppingBag" },
      { text: "Appointment booking system configured", icon: "Clock" },
      { text: "Payment system setup", icon: "CreditCard" },
      { text: "Domain connection and technical settings", icon: "Settings" },
      { text: "Initial marketing content created", icon: "TrendingUp" },
      { text: "Email marketing system setup", icon: "Mail" },
      { text: "SEO optimization and Google settings", icon: "Search" },
      { text: "Social media accounts connected", icon: "Users" },
      { text: "Personal training and handover", icon: "UserCheck" }
    ],
    note: "For both new and existing businesses"
  },
  enterprisePackage: {
    badge: "Pro",
    title: "Pro",
    subtitle: "For larger teams and businesses",
    priceLabel: "Custom pricing",
    priceSubtext: "Tailored to your needs",
    ctaButton: "Request a quote",
    tabStandard: "Standard",
    tabPro: "Pro",
    highlights: [
      "Everything in the Standard plan",
      "Fully custom pricing",
      "Dedicated account manager",
      "24/7 priority support",
      "AI assistant for daily work",
      "Custom API integration",
      "White-label solution",
      "Custom onboarding & training",
      "SLA guarantee",
      "Multi-user admin panel",
      "Unlimited team members",
      "Full GDPR compliance",
      "Prioritized feature requests"
    ]
  },
  products: {
    title: "What you get:",
    packagesTitle: "",
    aiCredits: {
      free: {
        title: "One-time credit",
        subtitle: "Credits are required to use AI."
      },
      paid: {
        title: "Monthly AI credit",
        subtitle: "Credits are required to use AI."
      }
    },
    starterItems: [
      "Complete website creation with AI assistant",
      "AI-powered appointment booking system with automatic reminders",
      "Digital product sales",
      "Online course sales",
      "Individual or group class sales",
      "Group workshop organization",
      "Membership and pass management",
      "AI-generated marketing content (social media posts, campaigns)",
      "Email marketing automation",
      "Email subscription forms"
    ],
    items: [
      "Digital products (e-books, templates, courses)",
      "Digital content (video, audio, music, etc.)",
      "Online consultations and mentoring",
      "Personalized video messages",
      "Webinar and workshop tickets",
      "Subscription exclusive content",
      "Chat and messaging services",
      "Coaching and consulting services",
      "Community access and networking"
    ],
    moreText: "and much more – we continuously expand our services.",
    freeExtras: [],
    starterExtras: [],
    growthExtras: [
      { text: "Custom domain", icon: "Globe" },
      { text: "Unlimited team management", icon: "UserCheck" }
    ],
    proExtras: [],
    eliteExtras: [
      { text: "Audience analytics", icon: "Users" },
      { text: "Conversion tracking", icon: "Target" },
      { text: "Content performance", icon: "Activity" },
      { text: "AI growth suggestions", icon: "Sparkles" }
    ],
    vipExtras: [
      { text: "Fully custom pricing", icon: "BadgePercent" },
      { text: "Dedicated account manager", icon: "UserCheck" },
      { text: "24/7 priority support", icon: "Headphones" }
    ]
  },
  features: [
    {
      title: "Hosting",
      description: "We provide unlimited bandwidth and storage for your site."
    },
    {
      title: "AI tools",
      description: "We help your work with intelligent content suggestions and analytics."
    },
    {
      title: "International payment system",
      description: "We provide secure and comprehensive payment options."
    },
    {
      title: "Local currencies",
      description: "You can sell your products in any country in the world."
    },
    {
      title: "Marketing features",
      description: "Our promotional and traffic-boosting solutions help with growth."
    },
    {
      title: "Billing",
      description: "We provide 100% automated billing that complies with the tax regulations of every European country."
    }
  ],
  cta: {
    button: "Join now",
    subtitle: "Registration is free, and you can sell your products today."
  },
  comparison: {
    title: "Compare how much you would earn elsewhere and how much on the Bespire platform.",
    competitors: [
      {
        name: "Traditional platforms",
        monthlyFee: "€20–€250",
        commission: "5–15%",
        hiddenCosts: "Yes"
      },
      {
        name: "Marketplace",
        monthlyFee: "Free",
        commission: "20–30%",
        hiddenCosts: "Yes"
      }
    ],
    labels: {
      monthlyFee: "Monthly fee",
      commission: "Commission",
      hiddenCosts: "Hidden costs",
      best: "BEST",
      bespire: "Bespire",
      simpleDescription: "The simple solution",
      traditionalDescription: "Traditional solution",
      startNow: "Start now",
      zero: "€0",
      none: "None"
    }
  },
  trust: {
    title: "We grow when you grow too",
    subtitle: "Join hundreds of creators who trust Bespire",
    button: "Start now for free",
    noFees: "No monthly fees, no hidden costs",
    backgroundAlt: "Trust section background image"
  },
  calculator: {
    title: "Calculate your costs",
    subtitle: "Find out exactly how much you would spend on the Bespire platform",
    monthlyRevenue: "Expected monthly gross revenue",
    currency: "€",
    revenueDescription: "Enter how much monthly gross revenue you expect",
    vatStatus: "VAT obligation",
    payVat: "I pay VAT (20%)",
    noVat: "I don't pay VAT",
    vatSubject: "You are VAT liable",
    vatNonSubject: "You are below the VAT threshold",
    breakdown: "Your monthly cost breakdown",
    grossRevenue: "Gross revenue",
    vat: "VAT (20%)",
    vatTooltip: "We handle this automatically for you internationally",
    platformFee: "Bespire platform fee (4% + €0.30)",
    netRevenue: "Your net revenue",
    vatInfo: "VAT handling automatically",
    vatDescription: "We handle VAT completely automatically for you internationally. You don't need to deal with this - we handle the declaration, payment and all administration. You only receive your net revenue.",
    disclaimer: "* Calculation based on domestic sales"
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Answers to the most common questions about our pricing",
    questions: [
      {
        question: "What are AI credits?",
        answer: "AI credits are used for the platform's intelligent features: AI assistant, content generation, image analysis, product offer optimization and other automation functions. The Starter package includes 50 one-time credits. The Growth package provides 125-1100 monthly credits depending on which AI credit tier you choose. The Ultimate package offers AI assistant for daily work."
      },
      {
        question: "What happens if I run out of monthly AI credits?",
        answer: "In the Starter package, the 50 credits are one-time, if you run out, you need to upgrade to a higher package. In the Growth package, your monthly credits automatically renew at the beginning of each month - you can either wait for the refill or choose a higher AI credit tier within your package. The Ultimate package provides AI assistant for daily work."
      },
      {
        question: "How long are credits valid?",
        answer: "The Starter package's 50 one-time credits are valid until used. The Growth package's monthly credits are automatically refilled at the beginning of each month according to your chosen credit tier (125-1100 credits). Unused credits from the previous month do not carry over to the next month."
      },
      {
        question: "Are there any hidden fees?",
        answer: "No. Both plans have the same commission: 4% + €0.30 fixed fee, but only if clients pay through us. The Starter package is completely free with no monthly fee. The Growth package has a monthly subscription fee (€19.9-€89.9 depending on your chosen AI credit tier), in return you get automatic monthly AI credits and pro features (team management, multi-location, detailed reports). No setup fees, hidden costs, or surprises."
      },
      {
        question: "How is the commission calculated?",
        answer: "The commission applies to the gross amount of each sale (before VAT deduction), but only if clients pay through us. Both packages have the same rate: 4% + €0.30 is deducted for each sale. We handle VAT automatically for you. If you handle payments directly, there's no commission."
      },
      {
        question: "When should I upgrade to a higher package?",
        answer: "The Growth package is worth it if you regularly use AI features and/or need pro features (team management, multi-location, detailed reports, loyalty program). The commission is the same in both packages (4% + €0.30), but with Growth you get automatic monthly AI credits (125-1100 credits), so you don't need to purchase separately. If you use AI intensively, the Growth package quickly pays for itself."
      },
      {
        question: "Can I change packages at any time?",
        answer: "Yes, you can switch to a lower or higher package at any time. If you upgrade, you can immediately enjoy the benefits (lower commission, more AI credits). If you downgrade, the change takes effect at the beginning of the next billing period."
      },
      {
        question: "What is the Ultimate package for?",
        answer: "The Ultimate package is designed for very successful creators who handle high volumes. We provide custom pricing, AI assistant for daily work, a dedicated account manager, 24/7 priority support, and API integration. Contact us for details."
      },
      {
        question: "When do I receive payment?",
        answer: "Your earnings are automatically transferred to your bank account according to local banking regulations, usually within 2-5 business days. VAT and commission are already deducted, so you only receive your net revenue."
      },
      {
        question: "What payment methods do you accept?",
        answer: "You can pay the monthly subscription with a bank card. For your customers, we provide a wide range of payment options: bank cards, PayPal, bank transfers and more than 20 local payment methods worldwide."
      }
    ]
  },
  additionalTokens: {
    title: "Additional AI Credits",
    description: "If you run out of monthly credits, you can always purchase more as a one-time purchase",
    explanation: "These packages are NOT standalone subscriptions - you can only purchase them if you already have an active subscription and have run out of your monthly credits. AI credits can be used for website creation with the AI assistant.",
    subtitle: "Credits are valid for 6 months from the date of purchase.",
    button: "Select Package",
    noExtra: "I don't need extra credits",
    packages: [
      { 
        credits: 100, 
        price: "9.90",
        label: "credits"
      },
      { 
        credits: 300, 
        price: "29.90",
        label: "credits"
      },
      { 
        credits: 500, 
        price: "44.90",
        label: "credits",
        popular: true,
        badge: "Most Popular"
      },
      { 
        credits: 1000, 
        price: "89.90",
        label: "credits"
      }
    ],
    priceLabel: "incl. VAT"
  },
  finalCta: {
    title: "Join hundreds of creators",
    subtitle: "Start selling today with our simple, transparent pricing. No setup fees.",
    button: "Start now",
    features: "Start free • No credit card needed • Only 4% + €0.30 commission"
  },
  footer: {
    features: "Features",
    support: "Support",
    newsletter: "Newsletter",
    newsletterDescription: "Subscribe to our newsletter and be the first to know about updates!",
    emailPlaceholder: "Enter your email address",
    subscribe: "Subscribe",
    affiliateProgram: "Affiliate program",
    copyright: "© 2025 Bespire. All rights reserved.",
    madeWithLove: "Made with ❤️ for creators",
    systemStatus: "System status: Operational",
    links: {
      products: "What can you sell?",
      comparison: "Comparison",
      faq: "FAQ",
      partnerProgram: "Partner program",
      getStarted: "Get started",
      contact: "Contact",
      privacy: "Privacy",
      terms: "Terms",
      aboutUs: "About us"
    },
    alerts: {
      privacy: "Privacy policy coming soon!",
      terms: "Terms and conditions coming soon!",
      socialClick: "Opening:",
      newsletter: "Newsletter subscription:"
    },
    socialPlatforms: {
      instagram: "instagram",
      twitter: "twitter",
      email: "email"
    }
  }
};